import { ORDER_ORIGIN } from '../../../../__queries__';

export interface BaseRefund {
  /** When the payment was made - this is needed for some payment methods */
  transactionCreatedAt: string;

  /** The payment transaction ID we are refunding */
  transactionId: string;

  /** The payment method we are refunding */
  method: string;

  /** The waiter who took the payment when it was made */
  waiterId: string;

  origin: ORDER_ORIGIN;

  orderId: string;

  onCompleted: (receiptError?: string) => void;

  onFail: (message?: string) => void;
}

export interface RefundProps extends BaseRefund {
  amount: number;
}

export interface Item {
  id: string;

  // We dont use this field right now, but its easier to understand
  // what "ID" is if we also add "itemId" (it's the ID of the OrderItem)
  itemId: string;

  /**
   * For some reason we need this to print the receipt.
   * I am not sure why.
   */
  entryId: string;

  categoryId: string;
  categoryName: string;
  vatRate: number;

  amount: number;
  discount: number;

  /**
   * Both of these are for printing the receipt
   */
  fraction: number;
  title: string;
}

export interface ItemRefund extends BaseRefund {
  type: 'ITEM';

  /** All the items to refund */
  items: Item[];
}

export interface OrderRefund extends BaseRefund {
  type: 'ORDER';

  /**
   * Important:
   * This is an array of the items that are not
   * yet refunded on the order.
   */
  items: Item[];

  /** On order refunds, also refund tip */
  tipAmount: number;
}

export interface TipRefund extends BaseRefund {
  type: 'TIP';

  origin: ORDER_ORIGIN;

  orderId: string;

  /** The tip after refunds */
  newTipAmount: number;

  /** What the tip was before the refund */
  previousTipAmount: number;
}

export type Refund = TipRefund | ItemRefund | OrderRefund;

export interface AdeynTerminal {
  IP: string | null;
  POIID: string;
}

export enum PAYMENT_TYPE {
  IZETTLE = 'IZETTLE',
  ADYEN = 'ADYEN',
  MICRODEB = 'MICRODEB',
  SURFBOARD = 'SURFBOARD',
  APP = 'APP',
  MULTIPAY = 'MULTIPAY',
  BAEMINGO_GIFTCARD = 'BAEMINGO_GIFTCARD',
  RETAIN24 = 'RETAIN24',
  CASH = 'CASH',
  CRYPTO = 'CRYPTO',
  WAITERAID = 'WAITERAID',
}
